<template>
  <div class="h5-container">
    <!-- 顶部导航栏 -->
    <van-nav-bar
      class="top-bar"
      title="消息"
      left-text="返回"
      left-arrow
      @click-left="goBack"
    />

    <!-- 会话列表 -->
    <div class="conversation-list">
      <div class="conversation-item" @click="goToChat">
        <div class="avatar">
          <van-icon name="service" size="22" color="#D4AF37" />
        </div>
        <div class="content">
          <div class="top-row">
            <span class="name">在线客服</span>
            <span class="time">{{ lastTime }}</span>
          </div>
          <div class="bottom-row">
            <span class="last-msg">{{ lastMessage || '点击开始咨询' }}</span>
            <van-badge v-if="unreadCount > 0" :content="unreadCount" class="badge" />
          </div>
        </div>
        <van-icon name="arrow" class="arrow" color="#666" />
      </div>
    </div>

    <!-- 空状态 -->
    <div class="empty-tip" v-if="!lastMessage && unreadCount === 0">
      <van-icon name="chat-o" size="56" color="#444" />
      <p>暂无消息，点击上方客服开始咨询</p>
    </div>
  </div>
</template>

<script>
import { memberInformation } from '@/api/mine'
import { getUnreadCount, getHistoryMessages } from '@/api/chat'

export default {
  name: 'Message',
  data() {
    return {
      userId: '',
      userType: 2,
      unreadCount: 0,
      lastMessage: '',
      lastTime: '',
      conversationKey: '',
      pollTimer: null
    }
  },
  created() {
    this.init()
  },
  mounted() {
    // 页面显示时启动轮询
    this.startPolling()
  },
  activated() {
    // keep-alive 页面激活时刷新
    this.refresh()
    this.startPolling()
  },
  deactivated() {
    this.stopPolling()
  },
  beforeDestroy() {
    this.stopPolling()
  },
  methods: {
    async init() {
      await this.getUserInfo()
      if (this.userId) {
        this.refresh()
      }
    },
    // 刷新未读数和最后消息
    async refresh() {
      if (!this.userId) return
      await Promise.all([
        this.loadUnreadCount(),
        this.loadLastMessage()
      ])
    },
    async getUserInfo() {
      try {
        const res = await memberInformation()
        if (res.code === 200 && res.data) {
          this.userId = String(res.data.id || res.data.userId || '')
        }
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    },
    // 加载未读数
    async loadUnreadCount() {
      try {
        const res = await getUnreadCount(this.userId, this.userType)
        if (res.code === 200) {
          this.unreadCount = res.data || 0
        }
      } catch (e) {
        console.error('获取未读数失败', e)
      }
    },
    // 加载最后一条消息（取最近1条历史）
    async loadLastMessage() {
      try {
        // 需要conversationKey才能查历史，先从本地取
        const key = localStorage.getItem('chat_conversation_key')
        if (key) {
          this.conversationKey = key
          const res = await getHistoryMessages(key, 1, 1)
          if (res.code === 200 && res.data && res.data.length > 0) {
            const msg = res.data[0] // 倒序，第一条就是最新的
            this.lastMessage = msg.content || ''
            this.lastTime = this.formatTime(msg.createTime)
            return
          }
        }
        // 没有历史消息，从本地存储取
        const lastMsg = localStorage.getItem('chat_last_message')
        if (lastMsg) {
          const msg = JSON.parse(lastMsg)
          this.lastMessage = msg.content || ''
          this.lastTime = this.formatTime(msg.createTime)
        }
      } catch (e) {
        console.error('加载最后消息失败', e)
      }
    },
    // 轮询刷新未读数（15秒一次，保证实时性）
    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => {
        this.loadUnreadCount()
      }, 15000)
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },
    goToChat() {
      this.$router.push('/app_chat')
    },
    goBack() {
      this.$router.replace('/app_home')
      // this.$router.back()
    },
    formatTime(time) {
      if (!time) return ''
      const date = new Date(time)
      const now = new Date()
      if (date.toDateString() === now.toDateString()) {
        return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
      }
      return `${date.getMonth() + 1}/${date.getDate()}`
    }
  }
}
</script>

<style scoped lang="scss">
.h5-container {
  min-height: 100vh;
  background-color: #1A1A1A;
  padding-bottom: 60px;
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);

  ::v-deep .van-nav-bar__title {
    color: #0f0f0f;
    font-weight: 600;
  }
  ::v-deep .van-nav-bar__text {
    color: #0f0f0f;
  }
  ::v-deep .van-icon-arrow-left {
    color: #0f0f0f;
  }
}

.conversation-list {
  margin-top: 10px;
  background: #222;
}

.conversation-item {
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-bottom: 1px solid #2a2a2a;

  &:active {
    background: #2a2a2a;
  }

  .avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #2a2a2a;
    border: 1px solid #D4AF37;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    min-width: 0;

    .top-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 6px;

      .name {
        font-size: 15px;
        font-weight: 500;
        color: #fff;
      }
      .time {
        font-size: 12px;
        color: #666;
      }
    }

    .bottom-row {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .last-msg {
        font-size: 13px;
        color: #888;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
        margin-right: 8px;
      }
    }
  }

  .arrow {
    margin-left: 8px;
    flex-shrink: 0;
  }
}

.empty-tip {
  text-align: center;
  padding: 80px 20px;
  color: #555;

  p {
    margin-top: 16px;
    font-size: 14px;
  }
}

/* PC适配：参考 home.vue / mine.vue 约定，放大头像、文字，留出底部导航避让 */
@media screen and (min-width: 768px) {
  .h5-container {
    min-height: 100vh; // 覆盖全局110vh，列表页无需过长
    padding-bottom: 100px; // PC端底部导航更高（80px），留出避让
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.5);
  }

  .conversation-list {
    margin-top: 16px;
  }

  .conversation-item {
    padding: 18px 20px;

    &:hover {
      background: #2a2a2a;
    }

    .avatar {
      width: 60px;
      height: 60px;
      margin-right: 16px;
    }

    .content {
      .top-row {
        margin-bottom: 8px;

        .name {
          font-size: 18px;
        }
        .time {
          font-size: 14px;
        }
      }

      .bottom-row {
        .last-msg {
          font-size: 15px;
        }
      }
    }
  }

  .empty-tip {
    padding: 120px 20px;
  }
}
</style>
